import fuzzysort from 'fuzzysort'
import getSlug from 'speakingurl'

export const filterItems = (items, query) => {
  if (query === '*') {
    return items
  } else {
    const fuzzysorted = fuzzysort.go(getSlug(query, '-'), items, {
      keys: ['slugName', 'file_number', 'originalNumber'],
      allowTypo: false,
    })
    return fuzzysorted.map(function (element) {
      return element.obj
    })
  }
}

export const prepareData = (data, type) => {
  for (const item of data) {
    item.type = type
    item.slugName = getSlug(item.name, '-')

    if (type === 'Account') {
      item.originalNumber = getSlug(item.original_number, '-')
    }
  }
  return data
}

export const limitSearchResults = (items, limit) => {
  return items.slice(0, limit)
}
